export default __webpack_public_path__ + "static/media/logo_zamoow.9b54a844.png";